export default __webpack_public_path__ + "static/media/closeIcon.02f5bcd8.svg";